import { render } from "./PubLayout.vue?vue&type=template&id=0dd5e900&scoped=true"
import script from "./PubLayout.vue?vue&type=script&lang=js"
export * from "./PubLayout.vue?vue&type=script&lang=js"

import "./PubLayout.vue?vue&type=style&index=0&id=0dd5e900&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0dd5e900"

export default script